/** a transformer for GET person request response */
const transformPersons = ({ identifier } = {}) =>
  identifier?.find((record) => record?.type?.code === 'MR') || {};

export default transformPersons;
